import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { getStripeCardDisplayName, type PaymentType } from 'src/app/shared/utils/payments';

import { useTracking } from '../useTracking';
import { useUpdateTrackingEventsWithGuestData } from '../useUpdateTrackingEventsWithGuestData';

export function useTrackModelSuccess(): (params: { paymentType: PaymentType; cardType?: string }) => void {
	const [{ usingSavedPaymentMethod }] = usePromotePageState();

	const {
		data: {
			comboBanditData,
			petition: { bandits },
			user: { savedPaymentMethods },
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();

	const { trackModelSuccess: trackModelSuccessInternal } = useTracking();

	const updatedName = useUpdateTrackingEventsWithGuestData();

	return function trackModelSuccess({ paymentType, cardType }) {
		const cardBrand = getStripeCardDisplayName(cardType, savedPaymentMethods, usingSavedPaymentMethod, paymentType);
		const { properties } = updatedName(paymentType);

		trackModelSuccessInternal({
			paymentType,
			cardBrand,
			comboBanditVariant: comboBanditData?.variant.variantName,
			comboBanditValue: comboBanditData?.variant.data.amount,
			promotedBanditValueShown: bandits?.contextualPromotionButtons?.selectedVariant?.data.amounts,
			foundationDonation: useDonationLanguage,
			...properties,
		});
	};
}
